import { useContext } from "react" 
import { Check, X as XIcon, Minus } from "lucide-react"


import { ReplaySessionContext } from '../context/ReplaySessionContext'
import { ReplayTerminalContext } from '../context/ReplayTerminalContext'

import '../../workspace/css/workspace.scss'

const PassIcon = ({ result }) => {
  if (result === true) return <div className="ws-test-icon ws-test-icon-passed"><Check className="ws-icon-md" /></div>
  if (result === false) return <div className="ws-test-icon ws-test-icon-failed"><XIcon className="ws-icon-md" /></div>
  return <div className="ws-test-icon ws-test-icon-pending"><Minus className="ws-icon-md" /></div>
}

export default function ReplayTestCases() {  
  
  const { session } = useContext(ReplaySessionContext)
  console.log('ReplayTestCases session:', session)
  const tests = session?.test_list || []

  const { testResults } = useContext(ReplayTerminalContext)

  return (
    <div className="ws-content-section">
      <h3 className="ws-section-title">Test Cases</h3>
      <div className="ws-test-table-wrapper">
        <table className="ws-test-table">
          <thead>
            <tr>
              <th>Name</th>
              <th className="ws-result-column">Result</th>
            </tr>
          </thead>
          <tbody>
            {(!tests || tests.length === 0) ? (
               <tr><td colSpan="2" style={{color: '#999', padding: '12px'}}>No tests defined</td></tr>
            ) : (
                tests.map((test, index) => {
                  const matchingResult = testResults.find(r => r.test_case_number === index + 1)
                  const status = matchingResult ? matchingResult.passed : null

                  return (
                    <tr key={index}>
                      <td>{test.name || `Test Case ${index + 1}`}</td>
                      <td className="ws-result-column">
                        <PassIcon result={status} />
                      </td>
                    </tr>
                  )
                })
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}